import { TOTAL_STEPS } from '../types';

export default function StepIndicator({ current }: { current: number }) {
  return (
    <div className="flex gap-2 mb-6">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map((n) => (
        <span
          key={n}
          data-testid="step-segment"
          data-active={String(n === current)}
          className={`h-1 flex-1 rounded-full ${
            n <= current ? 'bg-blue-600 dark:bg-blue-500' : 'bg-gray-200 dark:bg-gray-700'
          }`}
        />
      ))}
    </div>
  );
}
